import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { ReportingStore } from "../../ReportingStore";

class ReportingMiscHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.Reporting.Store_Mounted, this.StoreMounted);
    }

    private StoreMounted(request: LocalEvent, store: ReportingStore): void {
        store.ReportingActions.InitiateSingleSignOn();
        store.defaultsLoaded = true;
    }
}

export { ReportingMiscHandler };
